import React from "react";
import { useEffect, useState } from "react";
import NumberInput from "../shared/NumberInput";

export function OrderInformationFooter({buyScale, lockedSide, updateTotalOrderFee, updateTotalDeliveryFee, orderFeeC, denFeeC, deliveryFeeC, totalOrderC}){

    const [totalBuyAmount, setTotalBuyAmount] = useState(0);
    const [total, setTotal] = useState(0);
    const [totalFee, setTotalFee] = useState(0);
    const [totalDeliveryFee, setTotalDeliveryFee] = useState(0);
    const [totalOrderFee, setTotalOrderFee] = useState(0);
    const [totalDenominationFee, setTotalDenominationFee] = useState(0);


    useEffect(()=>{

         if(totalBuyAmount !== totalOrderC || totalOrderFee !== orderFeeC || totalDeliveryFee !== deliveryFeeC || totalDenominationFee !== denFeeC )
        {
            const orderFee = orderFeeC??0;
            const deliveryFeeRes = deliveryFeeC??0;
            const denFeeRes = denFeeC??0;

            if(totalBuyAmount !== totalOrderC){
               setTotalBuyAmount(totalOrderC);
            }

            if(totalDenominationFee !== denFeeRes){
               setTotalDenominationFee(denFeeRes);
            }

            if(totalOrderFee !== orderFee){
               setTotalOrderFee(orderFee);
            }

            if(totalDeliveryFee !== deliveryFeeRes){
               setTotalDeliveryFee(deliveryFeeRes);
            }
            setTotalFee(Number(orderFee??0) + Number(deliveryFeeRes??0))

            const finalTotal = (lockedSide === 'Buy')? (totalOrderC + denFeeRes) - (Number(orderFee??0) + Number(deliveryFeeRes??0)) : totalOrderC + (denFeeRes + Number(orderFee??0) + Number(deliveryFeeRes??0))

            setTotal(finalTotal);
        }

    },[totalOrderC, lockedSide, denFeeC, orderFeeC, deliveryFeeC])



   /*useEffect(()=>{

      if(totalOrderC > 0){
         setTotalBuyAmount(totalOrderC);
         const finalTotal = (lockedSide === 'Buy')? totalOrderC - (denFeeC + Number(orderFeeC??0) + Number(deliveryFeeC??0)) : totalOrderC + (denFeeC + Number(orderFeeC??0) + Number(deliveryFeeC??0))

         setTotal(finalTotal);
      }
   },[totalOrderC, lockedSide])*/

    const onChangeDeliveryFee = (event) =>{
        const fee = Number(event.target.value);
        setTotalDeliveryFee(fee);
        setTotalFee(totalOrderFee + fee)

        const finalTotal = (lockedSide === 'Buy')? (totalBuyAmount +totalDenominationFee) - (totalOrderFee + fee) :  totalBuyAmount + (totalDenominationFee + totalOrderFee + fee)
        setTotal(finalTotal);

        updateTotalDeliveryFee(fee);
    }

    const onChangeOrderFee = (event) =>{
        const fee = Number(event.target.value);
        setTotalOrderFee(fee);
        setTotalFee(fee +totalDeliveryFee)

        const finalTotal = (lockedSide === 'Buy')? (totalBuyAmount + totalDenominationFee) - (fee + totalDeliveryFee) :  totalBuyAmount + (totalDenominationFee + fee + totalDeliveryFee)
        setTotal(finalTotal);

        updateTotalOrderFee(fee);
        
    }

return (
    <>
      <div  align="right" className="uk-grid">
        
        <div  className="uk-width-2-3"></div>
        <div  className="uk-width-1-8 uk-form-controls">
         <span style={{fontWeight:'bold'}} >{'Subtotal'}</span>
         </div>
         <div className="uk-width-1-8 uk-form-controls">
            <NumberInput type="Currency" id={`txt-total-buy-amount`} key="txt-total-buy-amount" value={totalBuyAmount+totalDenominationFee} disabled={true} scale={buyScale} />
         </div>


         <div  className="uk-width-2-3"></div>
        <div  className="uk-width-1-8 uk-form-controls">
         <span style={{fontWeight:'bold'}}>{'Total Fee'}</span>
         </div>
         <div className="uk-width-1-8 uk-form-controls">
            <NumberInput type="Currency" id={`txt-total-Fee`} key="txt-total-Fee" value={totalFee} disabled={true} scale={buyScale} />
         </div>
        

       {/*  <div  className="uk-width-2-3"></div>
        <div  className="uk-width-1-8 uk-form-controls">
         <span >{'Denomination Fee'}</span>
         </div>
         <div className="uk-width-1-8 uk-form-controls">
            <NumberInput type="Currency" id={`txt-total-DenominationFee`} key="txt-total-DenominationFee" value={totalDenominationFee} disabled={true} scale={buyScale} />
         </div>*/}

         <div  className="uk-width-2-3"></div>
        <div  className="uk-width-1-8 uk-form-controls">
         <span >{'Order Fee'}</span>
         </div>
         <div className="uk-width-1-8 uk-form-controls">
            <NumberInput type="Currency" id={`txt-total-OrderFee`} key="txt-total-OrderFee" onChange ={onChangeOrderFee} value={totalOrderFee} scale={buyScale} />
         </div>

        <div  className="uk-width-2-3"></div>
        <div  className="uk-width-1-8 uk-form-controls">
         <span >{'Delivery Fee'}</span>
         </div>
         <div className="uk-width-1-8 uk-form-controls">
            <NumberInput type="Currency" id={`txt-total-DeliveryFee`} key="txt-total-DeliveryFee" onChange ={onChangeDeliveryFee} value={totalDeliveryFee} scale={buyScale} />
         </div>
         

         <div  className="uk-width-2-3"></div>
        <div  className="uk-width-1-8 uk-form-controls">
         <span style={{fontWeight:'bold'}}>{'Total'}</span>
         </div>
         <div className="uk-width-1-8 uk-form-controls">
            <NumberInput type="Currency" id={`txt-total`} key="txt-total" value={total} disabled={true} scale={buyScale} />
         </div>


      </div>
    
    </>
  );
}

export default OrderInformationFooter